export const SEARCH_PROJECT_CTA_KEY = "search-project-cta-v1";
/** Fixed enrollment stop: leaving a browser tab open cannot extend the pilot. */
export const SEARCH_PROJECT_CTA_END_AT = "2026-11-14T19:00:00Z";
export const SEARCH_PROJECT_CTA_FALLBACK = "Open this example in Crimp";
export type SearchProjectCtaVariant = "control" | "test";
export type SearchProjectTheme = "campervan-solar-alternator" | "boat-starter-house" | "dual-battery-redarc";
export type SearchProjectCtaContext = {
  experiment: typeof SEARCH_PROJECT_CTA_KEY;
  variant: SearchProjectCtaVariant;
  theme: SearchProjectTheme;
};

const THEMES = [
  { example: "campervan", variant: "solar-alternator", theme: "campervan-solar-alternator", label: "Edit this solar + alternator system" },
  { example: "boat", variant: "starter-house", theme: "boat-starter-house", label: "Edit this starter + house system" },
  { example: "dual-battery", variant: "redarc", theme: "dual-battery-redarc", label: "Edit this REDARC dual-battery system" },
] as const;

/** Public template identity only; units and diagram contents never enter the experiment. */
export function getSearchProjectTheme(handoff: { example: string; variant: string }): SearchProjectTheme | null {
  return THEMES.find((theme) => theme.example === handoff.example && theme.variant === handoff.variant)?.theme ?? null;
}

export function isSearchProjectTheme(value: unknown): value is SearchProjectTheme {
  return THEMES.some((item) => item.theme === value);
}

export function searchProjectCtaLabel(theme: SearchProjectTheme, variant: SearchProjectCtaVariant | null): string {
  if (variant === "control") return "Try Crimp";
  if (variant === "test") return THEMES.find((item) => item.theme === theme)?.label ?? SEARCH_PROJECT_CTA_FALLBACK;
  return SEARCH_PROJECT_CTA_FALLBACK;
}
